import { DistributorContract } from './distributor-contract';
import { DistributorContractAreaPostcode } from './distributor-contract-area-postcode';

export class DistributorContractArea
{
	id: number;
	distributorContract: DistributorContract;
	distributorContractAreaPostcodes: DistributorContractAreaPostcode[];
	delivery_street: string;
	delivery_house_number: string;
	delivery_postcode: string;
	delivery_city: string;
	distance_koppelstraat_twello: number;

	constructor()
	{
		this.distributorContractAreaPostcodes = [];
	}
}



// WEBPACK FOOTER //
// ./src/app/models/distributor-contract-area.ts